var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviders(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4a4 4 0 00-4 4v24a4 4 0 004 4h24a4 4 0 004-4V4a4 4 0 00-4-4z",
    fill: "#c87f00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.06 8.468l1.725 1.724 1.246-1.245a2.138 2.138 0 013.023 3.023l-1.246 1.245 1.725 1.725a1.5 1.5 0 010 2.12l-1.725 1.725-.77-.77a2.137 2.137 0 10-3.022 3.023l.77.77-1.725 1.725a1.5 1.5 0 01-2.122 0l-1.724-1.724-1.245 1.245a2.137 2.137 0 01-3.023-3.023l1.245-1.245-1.725-1.725a1.5 1.5 0 010-2.121l1.725-1.725.77.77a2.137 2.137 0 103.023-3.023l-.77-.77 1.724-1.724a1.5 1.5 0 012.122 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviders);
export default "/_next/static/images/142d2b3a3ad72e20d650a8ed30e4060f.svg";
export { ForwardRef as ReactComponent };